export default __webpack_public_path__ + "static/media/16.046df5aa.png";